<template>
  <div class="notification-box">
    <div class="box">
      <div class="notification-title">
        <span>Notification</span>
        <el-button type="text" @click="readAll">Read ALL</el-button>
      </div>
      <div class="notification-cont-box">
        <div
          class="notification-col"
          v-for="(item, index) in notificationList"
          :key="index"
        >
          <img :src="item.covey_user ? item.covey_user.photo : ''" />

          <div class="notification-cont">
            <div class="notification-left">
              <div class="notification-left-cont">
                {{ item.content
                }}<span
                  v-if="item.url"
                  class="orderurl"
                  @click.stop="goToOrderInfo(item.url)"
                  >Go to check it!</span
                >
              </div>
              <div class="notification-left-sender ellipsis1">
                <span class="notification-left-sender-name">{{
                  item.covey_user ? item.covey_user.realname : ""
                }}</span
                ><span>{{ item.create_time | formatTime }}</span>
              </div>
            </div>
            <div class="notification-right">
              <el-button
                type="text"
                @click="readNotification(item)"
                :disabled="
                  item.covey_message_record &&
                  item.covey_message_record.status === 1
                "
                >Check</el-button
              >
              <el-button type="text" @click="delNotification(item)"
                >Delete</el-button
              >
            </div>
          </div>
        </div>
      </div>
      <KtPag
        :pageCount="pageParams.count"
        :currentPage="pageParams.page"
        :limit="pageParams.limit"
        @onChange="onPageChange"
      ></KtPag>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import KtPag from "@/views/Comm/KtPag";
import { isURL } from "@/utils/comm";
export default {
  components: {
    KtPag,
  },
  data() {
    return {
      pageParams: {
        page: 1,
        limit: 10,
        count: 0,
      },
      notificationList: [],
    };
  },
  mounted() {
    this.getNotificationList();
  },
  filters: {
    formatTime(val) {
      if (val && moment(val).isValid())
        return moment(val).format("YYYY/MM/DD HH:mm:ss");
      else return "-";
    },
  },
  methods: {
    goToOrderInfo(url) {
      if (isURL(url)) {
        window.open(url);
      } else {
        let routeData = this.$router.resolve({
          path: url,
        });
        window.open(routeData.href);
      }
    },
    onPageChange({ page, limit }) {
      this.pageParams.page = page;
      this.pageParams.limit = limit;
      this.getNotificationList();
    },
    async getNotificationList() {
      let params = { ...this.pageParams };
      delete params.count;
      const { status, data, messages } =
        await this.$api.courseApi.getNotification(params);
      if (status === "0") {
        this.notificationList = data.rows;
        this.pageParams.count = data.count;
      } else {
        this.$message({
          type: "error",
          message: messages,
        });
      }
    },
    async readNotification(params) {
      let param = {
        c_id: params.c_id,
        r_id: params.covey_message_record
          ? params.covey_message_record.r_id
          : "",
      };
      for (let key in param) {
        if (!param[key]) delete param["key"];
      }
      const { status } = await this.$api.courseApi.readNotification(param);
      if (status === "0") {
        this.$message({
          type: "success",
          message: "success",
        });
        this.getNotificationList();
        this.$store.dispatch("SET_UNREAD_NUM");
      } else {
        this.$message({
          type: "error",
          message: "Failed to check notification",
        });
      }
    },
    async delNotification(params) {
      let param = {
        c_id: params.c_id,
        r_id: params.covey_message_record.r_id,
      };
      const { status } = await this.$api.courseApi.delNotification(param);
      if (status === "0") {
        this.$message({
          type: "success",
          message: "Successfully deleted",
        });
        this.getNotificationList();
        this.$store.dispatch("SET_UNREAD_NUM");
      } else {
        this.$message({
          type: "error",
          message: "Failed to check notification",
        });
      }
    },
    async readAll() {
      const { status } = await this.$api.courseApi.readAllNotification();
      if (status === "0") {
        this.getNotificationList();
        this.$store.dispatch("SET_UNREAD_NUM");
        this.$message({
          type: "success",
          message: "Successfully read all notifications",
        });
      } else {
        this.$message({
          type: "error",
          message: "Failed to read all notifications",
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/utils/vw.scss";
.notification-box {
  height: 100%;
  .box {
    padding: 24px 40px;
    box-sizing: border-box;
    border-radius: 8px;
    background-color: #fff;
    box-shadow: 0px 4px 32px 0px rgba(0, 0, 0, 0.08);
  }
  .kt-page {
    text-align: right;
  }
  .notification-title {
    height: 25px;
    font-size: 18px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #181d2c;
    line-height: 25px;
  }
  .notification-title {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
  .notification-cont-box {
    margin-top: vh(10);
    .notification-col {
      display: flex;
      border-bottom: 1px solid #e6e6e6;
      align-items: center;
      img {
        margin-right: 20px;
        // margin-top: 8px;
        width: 56px;
        height: 56px;
        border-radius: 50%;
      }
    }
    .notification-cont {
      width: 100%;
      display: inline-flex;
      flex-direction: row;
      justify-content: space-between;
      padding: 24px 0;
      box-sizing: border-box;
      .notification-left {
        .notification-left-cont {
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #181d2c;
          line-height: 22px;
          .orderurl {
            color: #f48c06;
            font-weight: 500;
            cursor: pointer;
            text-decoration: underline;
            margin-left: 10px;
            &:hover {
              //   color: #f48c06;
              opacity: 0.54;
            }
          }
        }
        .notification-left-sender {
          // height: vh(40);
          margin-top: 12px;
          font-size: 12px;
          font-family: PingFangSC-Semibold, PingFang SC;
          color: rgba(32, 16, 2, 0.5);
          // line-height: vh(40);
          span {
            margin-right: vw(40);
            // opacity: 0.58;
          }
        }
      }
      .notification-right {
        margin-left: vw(30);
        display: flex;
        flex-direction: row;
      }
    }
  }
  /deep/ .el-button--text {
    font-weight: 600;
    color: #f48c06;
  }
  /deep/ .el-button.is-disabled.el-button--text {
    color: #7e8088;
    opacity: 0.5;
  }
}
</style>